// Data layer for /innovators — talks to Supabase directly with the public anon key.
// No edge functions: RLS lets anon INSERT bids/applications and EXECUTE the leaderboard fn.
const SB_URL = process.env.REACT_APP_SUPABASE_URL;
const SB_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_KEY;

const headers = {
  apikey: SB_KEY,
  Authorization: `Bearer ${SB_KEY}`,
  'Content-Type': 'application/json',
};

export const backendReady = Boolean(SB_URL && SB_KEY);

export async function submitBid(bid) {
  const res = await fetch(`${SB_URL}/rest/v1/mm_community_bids`, {
    method: 'POST',
    headers: { ...headers, Prefer: 'return=minimal' },
    body: JSON.stringify(bid),
  });
  if (!res.ok) throw new Error(`Bid failed (${res.status})`);
}

export async function submitApplication(app) {
  const res = await fetch(`${SB_URL}/rest/v1/mm_community_applications`, {
    method: 'POST',
    headers: { ...headers, Prefer: 'return=minimal' },
    body: JSON.stringify(app),
  });
  if (!res.ok) throw new Error(`Application failed (${res.status})`);
}

export async function getTopBid() {
  try {
    const res = await fetch(`${SB_URL}/rest/v1/rpc/mm_current_top_bid`, {
      method: 'POST',
      headers,
      body: JSON.stringify({}),
    });
    if (!res.ok) return null;
    const rows = await res.json();
    return Array.isArray(rows) && rows[0] ? rows[0] : null;
  } catch {
    return null;
  }
}

export async function getBidCount() {
  try {
    const res = await fetch(`${SB_URL}/rest/v1/rpc/mm_bid_count`, {
      method: 'POST',
      headers,
      body: JSON.stringify({}),
    });
    if (!res.ok) return 0;
    const n = await res.json();
    return typeof n === 'number' ? n : 0;
  } catch {
    return 0;
  }
}

export async function getCurrentRoom() {
  try {
    const res = await fetch(`${SB_URL}/rest/v1/rpc/mm_current_room`, {
      method: 'POST',
      headers,
      body: JSON.stringify({}),
    });
    if (!res.ok) return null;
    const rows = await res.json();
    return Array.isArray(rows) && rows[0] ? rows[0] : null;
  } catch {
    return null;
  }
}

export async function getLedger() {
  try {
    const res = await fetch(
      `${SB_URL}/rest/v1/mm_community_events?select=event_date,winner_fund,winner_anchor,winning_amount,roster&status=eq.published&order=event_date.desc`,
      { headers }
    );
    if (!res.ok) return [];
    return res.json();
  } catch {
    return [];
  }
}
